// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ypgC","label":"styles_label__1skOt"};